import React, { Component } from 'react';
import propTypes from 'prop-types';
import { connect } from 'react-redux';

import SectionTitle from '../../../../../UI/Editor/EditSpace/EditorPane/RenderContent/title';
import ContentWrapper from '../../../../../UI/Editor/EditSpace/EditorPane/RenderContent/ContentWrapper';
import Organizations from './organizations';

class EditorSection extends Component {
  state = {};

  render() {
    const { title, sectionKey, previewPad, setTitleEditing, editor } =
      this.props;
    return (
      <ContentWrapper previewPad={previewPad}>
        <SectionTitle
          title={title}
          sectionKey={sectionKey}
          setTitleEditing={setTitleEditing}
          editor={editor}
        />
        <Organizations sectionKey={sectionKey} {...this.props} />
      </ContentWrapper>
    );
  }
}

EditorSection.propTypes = {
  title: propTypes.string.isRequired,
  sectionKey: propTypes.string.isRequired,
  previewPad: propTypes.objectOf(propTypes.object0),
};

EditorSection.defaultProps = {
  previewPad: null,
};

const mapStateToProps = (state) => ({
  activePlan: state.userInfoReducer.activePlan,
  subscriptionStatus: state.userInfoReducer.subscriptionStatus,
});

export default connect(mapStateToProps)(EditorSection);
